var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.key,staticClass:"event",class:( _obj = {
    started: _vm.started,
    ended: _vm.ended
  }, _obj[_vm.eventType] = true, _obj['predict-node'] =  _vm.predict, _obj ),style:(_vm.nodeStyle)},[_c('img',{attrs:{"src":_vm.src,"alt":""}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }